"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Filter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Filter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 226.771 229.179",
    enableBackground: "new 0 0 226.771 229.179"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".fingerprint01{fill:none !important;stroke:currentColor !important;}.fingerprint02{fill:currentColor !important;stroke:none !important;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M118.892,28.026c11.914,0.997,23.6,4.681,34.009,10.719c16.618,9.528,29.919,25.048,37.029,43.274 c3.494,8.86,5.482,18.33,6.051,27.882c0.2,2.996,0.383,5.995,0.43,8.997c0,1.715-1.51,3.237-3.163,3.221 c-1.71,0.106-3.311-1.451-3.303-3.224c-0.19-4.759-0.408-9.524-0.973-14.248c-1.333-10.958-4.86-21.621-10.359-31.075 c-9.764-16.969-25.779-29.95-44.086-35.656c-12.573-4-26.141-4.524-39.021-1.68c-14.353,3.13-27.787,10.607-38.266,21.237 c-9.588,9.587-16.688,21.781-20.472,34.985c-0.386,1.594-2.023,2.731-3.596,2.45c-1.871-0.214-3.249-2.369-2.642-4.233 c3.274-11.594,8.957-22.451,16.487-31.692c8.715-10.648,19.863-19.222,32.353-24.517C91.799,29.078,105.485,26.884,118.892,28.026z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.894,50.018c1.5-0.292,3.175,0.625,3.639,2.157c0.399,1.05,0.182,2.251-0.442,3.16 C16.509,67.107,11.112,80.393,8.48,94.259c-2.144,11.357-2.612,23.072-1.111,34.533c0.198,1.137,0.005,2.407-0.844,3.233 c-1.223,1.407-3.581,1.37-4.755-0.062c-0.755-0.779-0.822-1.929-0.933-2.963C-2.2,104.159,3.093,78.314,15.561,56.78 c0.995-1.775,2.077-3.496,3.168-5.21C19.21,50.776,20.005,50.2,20.894,50.018z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.76,105.987c1.815-0.295,3.632,1.342,3.666,3.297c1.864,24.184-2.496,48.975-12.604,70.869 c-7.209,15.715-17.325,29.901-29.472,41.659c-1.306,1.226-3.543,1.122-4.614-0.351c-1.123-1.27-1.062-3.507,0.129-4.734 c0.708-0.799,1.517-1.48,2.241-2.261c14.305-14.434,25.322-32.589,31.663-52.45c5.37-16.72,7.408-34.584,6.102-52.115 C108.633,108.035,110.022,106.207,111.76,105.987z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.321,105.688c1.75-0.186,3.449,1.349,3.46,3.173c-0.229,4.294-0.363,8.614,0.066,12.896 c0.932,10.076-1.58,20.444-6.931,28.937c-2.903,4.635-6.628,8.714-10.936,11.973c-1.111,0.836-2.321,1.953-3.801,1.689 c-1.61-0.138-2.934-1.751-2.814-3.412c-0.011-1.143,0.665-2.204,1.583-2.799c7.818-5.427,13.527-14.001,15.623-23.478 c0.91-4.061,1.218-8.281,0.764-12.422c-0.333-4.469-0.358-8.97-0.019-13.441C27.382,107.183,28.764,105.776,30.321,105.688z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M192.335,133.211c1.977-0.504,4.054,1.316,3.896,3.412c-1.153,22.791-5.89,45.399-13.997,66.661 c-0.344,1.001-1.075,1.881-2.078,2.197c-1.718,0.683-3.821-0.525-4.178-2.38c-0.219-0.795-0.046-1.625,0.259-2.366 c7.8-20.45,12.343-42.191,13.501-64.108C189.69,135.034,190.804,133.504,192.335,133.211z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.597,155.148c1.165-0.053,2.527,0.347,3.135,1.467c0.63,1.027,0.783,2.392,0.159,3.471 c-5.454,10.718-13.53,19.992-23.229,26.783c-0.976,0.677-2.006,1.544-3.261,1.399c-1.806-0.063-3.286-1.934-2.982-3.778 c0.095-1.04,0.772-1.937,1.612-2.48c8.724-5.888,16.102-13.944,21.232-23.319C46.966,157.197,47.779,155.354,49.597,155.148z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.822,166.829c1.579-0.396,3.309,0.628,3.778,2.225c0.271,0.862,0.194,1.833-0.232,2.633 c-6.634,12.984-15.674,24.66-26.518,34.157c-1.138,0.923-2.161,2.301-3.729,2.353c-1.628,0.125-3.171-1.193-3.363-2.861 c-0.201-1.219,0.364-2.483,1.307-3.22c10.858-9.156,19.915-20.584,26.477-33.376C71.976,167.79,72.808,167.018,73.822,166.829z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M153.213,189.034c1.346-0.315,2.82,0.376,3.478,1.627c0.518,0.921,0.54,2.102,0.122,3.074 c-4.132,10.736-9.228,21.079-15.204,30.85c-0.484,0.921-1.208,1.784-2.232,2.046c-1.476,0.474-3.184-0.299-3.822-1.752 c-0.485-1.018-0.412-2.29,0.19-3.241c5.947-9.649,11.007-19.878,15.091-30.506C151.225,190.085,152.148,189.259,153.213,189.034z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.449,28.983c-0.742-0.086-1.454-0.449-1.981-1.077c-1.114-1.33-0.971-3.347,0.321-4.504 c7.812-7.001,30.261-20.835,59.312-23.083c16.694-1.291,42.003,0.721,67.769,17.646c1.437,0.944,1.857,2.917,0.937,4.407 c-0.92,1.489-2.83,1.932-4.267,0.988c-24.342-15.99-48.241-17.892-64.004-16.673c-12.428,0.961-24.665,4.193-36.368,9.604 C58.969,20.544,52,25.374,48.826,28.218C48.144,28.829,47.278,29.079,46.449,28.983z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M219.219,108.746c-1.429-0.166-2.592-1.352-2.718-2.889c-0.559-6.805-1.75-13.593-3.541-20.177 c-3.37-12.383-8.852-24.104-16.294-34.837c-5.849-8.436-11.805-14.496-15.128-17.122c-1.352-1.069-1.606-3.073-0.566-4.475 c1.04-1.403,2.979-1.673,4.332-0.604c8.179,6.465,25.726,26.34,33.603,55.285c1.896,6.969,3.158,14.157,3.75,21.363 c0.144,1.757-1.117,3.307-2.817,3.464C219.629,108.773,219.422,108.769,219.219,108.746z"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    className: "fingerprint02",
    transform: "matrix(0.0642 -0.9979 0.9979 0.0642 82.2493 336.3342)",
    cx: "220.456",
    cy: "124.312",
    rx: "6.529",
    ry: "6.314"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    className: "fingerprint02",
    transform: "matrix(0.0642 -0.9979 0.9979 0.0642 -5.1079 68.59)",
    cx: "34.018",
    cy: "37.019",
    rx: "6.529",
    ry: "6.314"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    className: "fingerprint02",
    transform: "matrix(0.0642 -0.9979 0.9979 0.0642 46.3927 167.6879)",
    cx: "112.606",
    cy: "59.108",
    rx: "8.76",
    ry: "8.472"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "fingerprint01",
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: "7",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M80.367,152.335 c5.187-14.213,5.099-22.284,4.29-32.237c-1.071-13.17,3.837-27.947,16.978-33.562c13.471-5.756,27.147,1.053,32.335,13.16 c8.481,19.795,9.51,69.704-31.47,125.984"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "fingerprint01",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "6.5",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M132.483,63.559 c0,0,20.679,7.71,29.496,30.345c8.946,22.964,2.595,64.747-2.42,81.591"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "fingerprint01",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "6.5",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M92.037,62.935 c0,0-17.562,6.286-27.234,24.214c-8.235,15.265-7.37,27.285-7.197,31.847c0.173,4.562,1.232,7.238-1.448,22.46"
  }));
}